<template>
  <div>
    <template v-for="(item, index) in breadCrumbList">
      <div :key="index" class="bread-crumb-item">
        <!-- link の場合 -->
        <template v-if="item.path">
          <a @click="onClickLink(item.path)" class="link">
            {{ item.title }}
          </a>
        </template>

        <!-- 単純なテキストの場合 -->
        <template v-if="!item.path">
          <p class="text">{{ item.title }}</p>
        </template>

        <!-- つなぎの矢印 -->
        <template v-if="index !== breadCrumbList.length - 1">
          <div class="arrow">
            >
          </div>
        </template>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BreadCrumbTemplate',
  props: {
    breadCrumbList: Array,
  },
  methods: {
    onClickLink(path) {
      this.$router.push(path).catch(() => {})
    },
  },
}
</script>

<style scoped>
.bread-crumb-item {
  display: inline-block;
}
.text {
  display: inline-block;
  margin: 0;
}
.link {
}
.arrow {
  display: inline-block;
  margin: 0 5px;
}
</style>
